import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

class Background extends React.Component {
    render() {
        return <div class="image"></div>;
    }
}

class Header extends React.Component {
    render() {
        return <div class="header">
            beantaco <br />
            <small><strike>a cautionary tale about fantasia addiction</strike></small><br />
            <small>a (very) lala-sized love story</small>
        </div>;
    }
}

class App extends React.Component {
  render() {
    return (
        <div>
            <Background />
            <Header />
            <div class="content">
                <section>
                    <header>SO THIS CATGIRL AND THIS ROE</header>
                    <img src="images/yuu-cat-min.png"/>
                    <img src="images/doc-roe-min.png"/>
                    <p>the adorable little popotos pictured above started life as these GIANTS. through the power of <strike>fantasia addiction</strike> love, they transformed into the innocent beings pictured above.</p>
                </section>

                <section>
                    <header>met in the mist</header>
                    <img src="images/mist.png"/><br />
                    <p>these MAMMOTHS lived next to each other in the mist. naturally, they were able to see each other from across the street, because creatures as MOUNTAINOUS as these can see over anything. a friendship began to form.</p>
                </section>

                <section>
                    <header>and bonded over fates.</header>
                    <img src="images/fates-1.png" /><br />
                    <p>they partied together for FATEs to level alts (alts are a cheaper version of fantasia) until they would pass out from exhaustion. many deaths were experienced due to sleepy heals.</p>
                    <img src="images/fate-dead.png" /><br />
                </section>

                <section>
                    <header>there was some light stalking</header>
                    <img src="images/stalking-1.png" /><br />
                    <img src="images/stalking-2.png" /><br />
                    <p>^ some totally-normal, 100%-not-creepy stalking.</p>
                </section>

                <section>
                    <header>and SO MANY FANTASIAS.</header>
                    <img src="images/alts-1.png" /><br />
                    <img src="images/alts-2.png" /><br />
                    <img src="images/chillin.png" /><br />
                    <p>(most did not live long enough to have their picture taken)</p>
                </section>

                <section>
                    <header>after 2.5 years, they got married :D</header>
                    <img src="images/wedding-2.png" /><br />
                    <img src="images/wedding-3.png" /><br />
                    <img src="images/wedding-1.png" /><br />
                    <img src="images/wedding-4.png" /><br />
                    <p>AND THEY COULDN'T BE HAPPIER.</p>
                </section>
            </div>
        </div>
    );
  }
}

const element = <App />;
ReactDOM.render(element, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js